import { buildModelManager } from "../builder.js";
const DefaultAuditEntrySelection = {
  __typename: true,
  id: true,
  action: true,
  createdAt: true,
  detail: true,
  ipAddress: true,
  profileId: true,
  resourceId: true,
  resourceLabel: true,
  resourceType: true,
  updatedAt: true,
  userId: true
};
const modelApiIdentifier = "auditEntry";
const pluralModelApiIdentifier = "auditEntries";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAuditEntrySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAuditEntrySelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAuditEntrySelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAuditEntrySelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAuditEntrySelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAuditEntrySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAuditEntrySelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "auditEntryGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AuditEntryManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAuditEntrySelection,
  operations
);
export {
  AuditEntryManager,
  DefaultAuditEntrySelection
};
//# sourceMappingURL=AuditEntry.js.map
